import { render, staticRenderFns } from "./JVxeInputCell.vue?vue&type=template&id=5c85ba1c&scoped=true"
import script from "./JVxeInputCell.vue?vue&type=script&lang=js"
export * from "./JVxeInputCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c85ba1c",
  null
  
)

export default component.exports